import { Editor } from "@tiptap/core";
import React, { useMemo } from "react";
import { Stack, Typography } from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import {
  H1Icon,
  H2Icon,
  H3Icon,
  BulletPointsIcon,
  NumberListIcon,
  ChecklistIcon,
  BlockQuotesIcon,
  CodeIcon,
  TextIcon,
  DownArrowIcon,
} from "components/icons";

export const TurnIntoIcon = ({ editor }: { editor: Editor }) => {
  if (!editor) return null;

  const currentNodeType = useMemo(() => {
    // Check for heading levels
    if (editor.isActive("heading", { level: 1 })) {
      return { icon: <H1Icon />, name: "Heading 1" };
    }
    if (editor.isActive("heading", { level: 2 })) {
      return { icon: <H2Icon />, name: "Heading 2" };
    }
    if (editor.isActive("heading", { level: 3 })) {
      return { icon: <H3Icon />, name: "Heading 3" };
    }

    // Check for list types
    if (editor.isActive("bulletList")) {
      return { icon: <BulletPointsIcon />, name: "Bullet List" };
    }
    if (editor.isActive("orderedList")) {
      return { icon: <NumberListIcon />, name: "Numbered List" };
    }
    if (editor.isActive("taskList")) {
      return { icon: <ChecklistIcon />, name: "Checklist" };
    }

    // Check for block types
    if (editor.isActive("blockquote")) {
      return { icon: <BlockQuotesIcon />, name: "Quote" };
    }
    if (editor.isActive("codeBlock")) {
      return { icon: <CodeIcon />, name: "Code" };
    }

    // Default to paragraph/text
    return { icon: <TextIcon />, name: "Text" };
  }, [editor.state.selection]);

  return (
    <Stack
      direction="row"
      spacing={1}
      alignItems="center"
      // sx={{ width: "100px" }}
    >
      <Stack
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {currentNodeType.icon}
      </Stack>
      <Typography variant="body-medium">{currentNodeType.name}</Typography>
      <DownArrowIcon />
    </Stack>
  );
};
